<template>
  <v-container id="taxslab-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              {{
              id ? $i18n.t("Edit Invocie Configuration") : $i18n.t("Create Invocie Configuration")
              }}
            </div>
          </template>

          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="3">
                  <z-entity-select
                    class="purple-input"
                    v-model="config.vendorEntity_id"
                    :label="$i18n.t('Serving Entity')"
                    corp="self"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <z-client-select class="purple-input" v-model="config.client_id" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-entity-select
                    class="purple-input"
                    v-model="config.clientEntity_id"
                    :corp="config.client_id"
                    :label="$i18n.t('Client Entity')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-checkbox
                    v-model="config.showPaxCompany"
                    :label="$i18n.t('Show Company Name in Personal Invoice')"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-checkbox
                    v-model="config.showPaxCompanyAddress"
                    :label="$i18n.t('Show Company Address in Personal Invoice')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-checkbox
                    v-model="config.hasMultiTaxSlab"
                    :label="$i18n.t('Has Multiple Tax Slabs')"
                  />
                </v-col>
                <v-col cols="12" md="3" v-if="!config.hasMultiTaxSlab">
                  <v-select
                    v-model="config.taxSlab_id"
                    :label="$i18n.t('Tax Slab')"
                    :items="taxSlabList"
                    item-text="name"
                    item-value="_id"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="config.poNo" :label="$i18n.t('PO Number')" />
                </v-col>
              </v-row>

              <v-row v-if="config.hasMultiTaxSlab">
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Multiple Tax Slabs") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="config.taxSlabs = newItem(config.taxSlabs)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in config.taxSlabs" :key="'item' + index">
                          <td>
                            <v-row>
                              <v-text-field
                                v-model="item.maxAmt"
                                :label="$i18n.t('Upto Amount')"
                                type="number"
                              />
                            </v-row>
                          </td>
                          <v-col cols="12" md="3">
                            <v-select
                              v-model="item.taxSlab_id"
                              :label="$i18n.t('Tax Slab')"
                              :items="taxSlabList"
                              item-text="name"
                              item-value="_id"
                            />
                          </v-col>
                          <td>
                            <v-checkbox v-model="item.isDefault" :label="$i18n.t('Is Default')" />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(config.taxSlabs, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Credit Card Config") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="config.cardSurcharges = newItem(config.cardSurcharges)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in config.cardSurcharges" :key="'item' + index">
                          <td>
                            <v-text-field v-model="item.cardName" :label="$i18n.t('Card Name')" />
                          </td>
                          <td>
                            <v-row>
                              <v-text-field
                                v-model="item.amount"
                                :label="$i18n.t('Amount')"
                                type="number"
                              />
                              <toggle-button
                                v-model="item.isAbs"
                                :labels="{ checked: '/-', unchecked: '%' }"
                                lg
                                :height="30"
                                :width="70"
                                :font-size="20"
                              />
                            </v-row>
                          </td>
                          <td>
                            <v-text-field v-model="item.desc" :label="$i18n.t('Descriptin')" />
                          </td>
                          <td>
                            <v-checkbox v-model="item.notTaxable" :label="$i18n.t('Not Taxable')" />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(config.cardSurcharges, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("LUT No. Config") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="config.taxAuths = newItem(config.taxAuths)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in config.taxAuths" :key="'item' + index">
                          <td>
                            <v-text-field v-model="item.lutNo" :label="$i18n.t('LUT No.	')" />
                          </td>
                          <td>
                            <z-date-picker v-model="item.startDate" :label="$i18n.t('Start Date')" />
                          </td>
                          <td>
                            <z-date-picker v-model="item.expiryDate" :label="$i18n.t('End Date')" />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(config.taxAuths, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Invoice Format Config") }}</h3>
                        </v-col>
                        <v-spacer />
                        <v-col clos="12" md="6">
                          <v-btn
                            @click="config.formats = newItem(config.formats)"
                            small
                            style="width:60px;float:right;"
                            color="light-blue"
                            text
                          >
                            <v-icon>mdi-plus</v-icon>
                            <h3>{{ $i18n.t("Add") }}</h3>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-simple-table dense style="padding: 10px">
                      <tbody>
                        <tr v-for="(item, index) in config.formats" :key="'item' + index">
                          <td>
                            <v-select
                              :items="formatsData"
                              item-text="name"
                              item-value="value"
                              v-model="item.type"
                              :label="$i18n.t('Format Type')"
                            />
                          </td>
                          <td>
                            <v-checkbox
                              v-model="item.plannedAddress"
                              :label="$i18n.t('Planned Address')"
                            />
                          </td>
                          <td>
                            <v-checkbox v-model="item.withMap" :label="$i18n.t('With Map')" />
                          </td>
                          <td>
                            <v-checkbox
                              v-model="item.forIndividual"
                              :label="$i18n.t('For Individual')"
                            />
                          </td>
                          <td>
                            <v-btn
                              class="float-right"
                              color="error"
                              small
                              fab
                              text
                              dark
                              @click="remove(config.formats, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <v-spacer></v-spacer>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="id">
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Corporate Logo") }}/{{$i18n.t("Invoice Stamp")}}</h3>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <v-img :label="$i18n.t('Company Logo')" :src="config.vendorLogo" />
                        <z-confirm-button
                          v-if="config.vendorLogo"
                          class="float-right"
                          color="red lighten-1"
                          small
                          fab
                          text
                          dark
                          :message="$i18n.t('Do you want to delete this company logo ?')"
                          @click="removeLogo('vendorlogo')"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </z-confirm-button>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <v-img :label="$i18n.t('Invoice Stamp')" :src="config.invoiceStamp" />
                        <z-confirm-button
                          v-if="config.invoiceStamp"
                          class="float-right"
                          color="red lighten-1"
                          small
                          fab
                          text
                          dark
                          :message="$i18n.t('Do you want to delete this invoice stamp ?')"
                          @click="removeLogo('invoicestamp')"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </z-confirm-button>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <v-file-input
                          chips
                          :label="$i18n.t('Company Logo')"
                          @change="handleImageUpload()"
                          v-model="logoFile"
                        ></v-file-input>
                        <v-btn
                          v-if="logoFile"
                          color="purple lighten-2"
                          small
                          v-on:click="uploadImage(logoFile, 'vendorlogo')"
                        >
                          <h3>{{ $i18n.t("Upload") }}</h3>
                        </v-btn>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <v-file-input
                          chips
                          :label="$i18n.t('Invoice Stamp')"
                          @change="handleImageUpload1()"
                          v-model="invStamp"
                        ></v-file-input>
                        <v-btn
                          v-if="invStamp"
                          color="purple lighten-2"
                          small
                          v-on:click="uploadImage(invStamp, 'invoicestamp')"
                        >
                          <h3>{{ $i18n.t("Upload") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card>
                    <v-list-item-content calss="px-3">
                      <v-row>
                        <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Terms and Conditions")}}</h3>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-col cols="12" md="10">
                      <vue-editor v-model="config.tnc"></vue-editor>
                    </v-col>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

import { VueEditor, Quill } from "vue2-editor";

@Component({
  components: { VueEditor, Quill },
})
export default class Tickets extends Vue {
  config = { formats: [], cardSurcharges: [], taxAuths: [], taxSlabs: [] };
  id = null;
  logoFile = null;
  taxSlabList = [];
  invStamp = null;
  formatsData = [
    { value: 0, name: "Trip Details (PDF)" },
    { value: 1, name: "Trip Details With Map(PDF)" },
    { value: 2, name: "Consolidate (PDF)" },
    { value: 3, name: "Manual (PDF)" },
    { value: 31, name: "Manual 2 (PDF)" },
    { value: 4, name: "Type-A_India (PDF)" },
    { value: 5, name: "Type-B_India (PDF)" },
    { value: 6, name: "Type-C_India (PDF)" },
    { value: 7, name: "Type-D_India (PDF)" },
    { value: 71, name: "Type-D1_India (PDF)" },
    { value: 8, name: "Type-E (PDF)" },
    { value: 81, name: "Type-F (PDF)" },
    { value: 9, name: "Type-G (PDF)" },
    { value: 10, name: "Type-H (PDF)" },
    { value: 11, name: "Type-I (PDF)" },
  ];

  handleImageUpload(files) {
    if (files) {
      this.logoFile = files[0];
    }
  }

  handleImageUpload1(files) {
    if (files) {
      this.invStamp = files[0];
    }
  }

  async uploadImage(file, type) {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.id) {
        formData.set("_id", this.config._id);
        formData.set("name", type);
      }
      if (file) {
        formData.append("file", file);
      }
      const url = "/api/invoiceconfig/" + this.config._id + "/" + type;
      await doPostForm(url, formData);
      common.setLoading(false);
      this.get(this.id);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async removeLogo(type) {
    common.setLoading(true);
    try {
      await doGet(
        "/api/invoiceconfig/" + this.config._id + "/" + type + "/remove"
      );
      this.get(this.id);
      common.setLoading(false);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const response = await doPost("/api/invoiceconfig/save", this.config);
      if (!this.id) this.$router.push("/invoiceconfig/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/invoiceconfig/" + id + "/detail");
      if (!response.formats) response.formats = [];
      if (!response.cardSurcharges) response.cardSurcharges = [];
      if (!response.taxSlabs) response.taxSlabs = [];
      if (!response.taxAuths) response.taxAuths = [];
      this.config = response;
      this.id = this.config._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    this.taxSlabList = await doGet("/api/taxslab/all");
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
